class preWarnCtrl {
    constructor($rootScope, $scope, httpRequest) {
        // 初始化表单数据
        // 用户信息
        const { userInfo } = $rootScope
        // 存储页面信息
        $scope.pageState = {
            idToken: $rootScope.idToken,
            userInfo,
            assignUkeyList: [],
        }

        // 开票点
        httpRequest.post_getAssignUkeyList().then((res) => {
            $scope.pageState.assignUkeyList = res.data.value
        })
        const typecodeArr = '["compare_type","compare_data_type"]'
        httpRequest.get_dictByTypeArr(typecodeArr).then((res) => {
            $scope.dictData = $.extend($scope.dictData, res.data.value)
        })
    }
}

preWarnCtrl.$inject = ['$rootScope', '$scope', 'httpRequest']
export default preWarnCtrl



// WEBPACK FOOTER //
// ./src/app/system/settingcenter/preWarn/preWarnCtrl.js